import React, { Component } from 'react';
import i18next from "../../i18n";
import { readAsUint8Array, urltoFile } from '../helpers/HelperFunctions';
import PropTypes from 'prop-types';
import { showModalDialog, hideModalDialog } from '../ModalDialog';
import { signatureStates, resources } from '../../constants';
/*
	Ідентифікатор батківського елементу для відображення iframe, 
	який завантажує сторінку SignWidget
*/
const SIGN_WIDGET_PARENT_ID = "sign-widget-parent";
/*
	Ідентифікатор iframe, який завантажує сторінку SignWidget
*/
const SIGN_WIDGET_ID = "sign-widget";
/*
	URI з адресою за якою розташована сторінка SignWidget
*/
const SIGN_WIDGET_URI = "https://eu.iit.com.ua/sign-widget/v20240301/";
export async function checkSertificates(docsIds = [], sertificates) {
    let companyId = JSON.parse(localStorage?.getItem('user'))?.companies[0]?.id;
    const { withoutStamp, withoutSign, maxSignsCountAdded, stampIsRequired } = this.props;
    let { subjEDRPOUCode, subjDRFOCode } = sertificates[0].infoEx;
    if (subjDRFOCode)
        subjDRFOCode = subjDRFOCode.trim();
    for (let i = 0; i < docsIds.length; ++i) {
        let error = await fetch(`File/GetSignatures/${docsIds[i].split("/").pop()}`)
            .then(async (response) => {
                if (!response.ok) {
                    if (!this.state.notShowError) require('../ModalDialogsTemplates').unknownErrorMessageDialog();
                    if (this.props.handlerError) this.props.handlerError();
                }
                else {
                    let data = await response.json();
                    let signatures = data.signatures.filter((s) => s.state === signatureStates.signed &&
                        (s.signatureCounterparty === null || s.signatureCounterparty === '' || s.signatureCounterparty.endsWith(companyId)));
                    if (!subjDRFOCode && signatures.length === 0) {
                        return { error: i18next.t("2"), keyLoaded: false };
                    }
                    else if (withoutStamp) {
                        if (!subjDRFOCode) return { error: i18next.t("1"), keyLoaded: false };
                    }
                    else if (withoutSign) {
                        if (!subjEDRPOUCode || (subjEDRPOUCode && subjDRFOCode)) {
                            let errorTextKey = "0";
                            if (maxSignsCountAdded) {
                                errorTextKey = stampIsRequired ? "maxSignsCountAddedError" : "maxSignsCountAddedErrorStampNotRequired";
                            }
                            return { error: i18next.t(errorTextKey), keyLoaded: false };
                        }
                    }
                }
            });
        if (error) return error;
    }
    return { keyLoaded: true, error: "" };
}
export class SignForm extends Component {
    static propTypes = {
        withoutStamp: PropTypes.bool,
        withoutSign: PropTypes.bool,
        stampIsRequired: PropTypes.bool,
        maxSignsCountAdded: PropTypes.bool,
        handlerRestart: PropTypes.func,
        handlerError: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            badExtension: false,
            sending: false,
            submitted: false,
            keyLoaded: false,
            files: this.props.files,
            euSign: null,
            showLoading: false,
            errorDialogId: this.props.errorDialogId ?? 'modalDialog',
            notShowError: this.props.notShowError,
        };
        this.onCancel = this.onCancel.bind(this);
        this.onSign = this.onSign.bind(this);
        this.signFile = this.signFile.bind(this);
        this.showErrorDialog = this.showErrorDialog.bind(this);
    }
    componentDidMount() {
        const { files } = this.state;
        if (files && files.length > 0) {
            let euSign = new window.EndUser(
                SIGN_WIDGET_PARENT_ID,
                SIGN_WIDGET_ID,
                SIGN_WIDGET_URI,
                window.EndUser.FormType.ReadPKey
            );
            let currentObject = this;
            var signIframe = document.querySelector(`#${SIGN_WIDGET_ID}`);
            if (signIframe) {
                this.setState({ euSign: euSign, showLoading: true });
                signIframe.addEventListener('load', function () {
                    currentObject.setState({ showLoading: false });
                });
            } else {
                this.setState({ euSign: euSign });
            }
            euSign.ReadPrivateKey()
                .then(async (sertificates) => {
                    await checkSertificates.bind(currentObject)(files.map((item) => item.id), sertificates).then((data) => {
                        if (data?.error)
                            currentObject.showErrorDialog(data.error);
                        else
                            currentObject.setState({ error: data?.error, keyLoaded: data?.keyLoaded, sending: data?.sending });
                    });
                    currentObject.setState({ euSign: euSign });
                });
        }
    }
    componentWillUnmount() {
        this.state.euSign.destroy();
    }
    showErrorDialog(error) {
        const currentObject = this;
        const { errorDialogId, notShowError } = this.state;
        let handlerClose = () => {
            if (currentObject.props.handlerRestart) {
                currentObject.props.handlerRestart(false);
            }
            hideModalDialog(errorDialogId);
        };
        if (notShowError)
            handlerClose();
        else
            showModalDialog(errorDialogId, i18next.t("error"), "", <div className="info-message">{error}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: handlerClose, class: "btn-primary" }], handlerClose);
    }
    onCancel() {
        const { onCloseHandler } = this.props;
        if (!this.state.sending && onCloseHandler)
            onCloseHandler();
    }
    async signFile(file) {
        let currentObject = this;
        const data = await readAsUint8Array(file);
        var external = false;
        var asBase64String = true;
        var signAlgo = window.EndUser.SignAlgo.EU_CTX_SIGN_DSTU4145_WITH_DSTU7564;
        var signType = window.EndUser.SignType.CAdES_X_Long;
        return new Promise((resolve, reject) => {
            this.state.euSign.SignData(data, external,
                asBase64String, signAlgo, null, signType)
                .then(function (sign) {
                    currentObject.setState({ error: '', keyLoaded: true, sending: false });
                    urltoFile('data:application/pkcs7-signature;base64,' + sign, file.name + '.p7s', 'application/pkcs7-signature')
                        .then(function (file) {
                            resolve(file);
                        })
                })
                .catch(function (e) {
                    let error = (e.message || e);
                    currentObject.setState({ error: error, sending: false });
                });;
        });
    }
    async onSign(e) {
        e.preventDefault();
        if (!this.state.sending) {
            const { errorDialogId, notShowError } = this.state;
            this.setState({ sending: true });
            let currentObject = this;
            this.state.euSign.ReadPrivateKey()
                .then(async (sertificates) => {
                    let isStamp = false;
                    let { files } = currentObject.state;
                    await checkSertificates.bind(currentObject)(files.map((item) => item.id), sertificates).then(async (data) => {
                        if (data?.error) {
                            let handlerClose = () => {
                                if (currentObject.props.handlerRestart) {
                                    currentObject.props.handlerRestart(false);
                                }
                                hideModalDialog(errorDialogId)
                            };
                            if (notShowError)
                                handlerClose();
                            else
                                showModalDialog(errorDialogId, i18next.t("error"), "", <div className="info-message">{data.error}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: handlerClose, class: "btn-primary" }], handlerClose);
                        }
                        else {
                            let { subjEDRPOUCode, subjDRFOCode } = sertificates[0].infoEx;
                            if (subjDRFOCode)
                                subjDRFOCode = subjDRFOCode.trim();
                            isStamp = !!subjEDRPOUCode && !subjDRFOCode;

                            let signs = [];
                            for (var i = 0; i < files.length; i++) {
                                let file = await currentObject.signFile(files[i].value);
                                signs.push({ id: files[i].id, value: file });
                            }
                            if (currentObject.props.onSignHandler)
                                currentObject.props.onSignHandler(signs, isStamp);
                        }
                    });
                })
        }
    }
    render() {
        const { keyLoaded, files, error, showLoading } = this.state;
        if (files && files.length > 0) {
            return (
                <>
                    <div className="modal-body">
                        <form name="form" className="popupSimple file-sign-form">
                            {showLoading && <img src={resources.loadingIcone} className="loading-icone" alt="" />}
                            <div className="keyErrorDialog"></div>
                            <div className="row">
                                <div className="form-group col-sm-12 col-xs-12">
                                    {/*
		                        Батківський елемент для відображення iframe,
		                        який завантажує сторінку SignWidget
	                            */}
                                    <div id={SIGN_WIDGET_PARENT_ID} style={{ width: "100%", height: "500px" }}>
                                    </div>
                                    {error &&
                                        <div className="file-sign-form-error">
                                            {i18next.t("form.sign.errorWhileSigning") + i18next.t("form.sign.errorDescription") + error}
                                        </div>
                                    }
                                </div>
                                {keyLoaded &&
                                    <div className="form-group col-sm-12 col-xs-12">
                                        <label>{i18next.t("form.sign.filesForSignature")}</label>
                                        <ul>
                                            {files.map((file, index) =>
                                                <li key={index}>{file.value.name}</li>
                                            )}
                                        </ul>
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <div className="form-group form-group__last">
                            {keyLoaded &&
                                <button className="btn btn-primary" onClick={this.onSign}>{i18next.t("sign")}</button>
                            }
                            <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{i18next.t("cancel")}</button>
                            <div className="required-label">
                                <label className="required" />{i18next.t("requiredFields")}
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else {
            return <>
                <div className="modal-body">
                    {i18next.t("noFilesToSign")}
                </div>
                <div className="modal-footer">
                    <div className="form-group">
                        <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{i18next.t("cancel")}</button>
                    </div>
                </div>
            </>
        }
    }
}
